import TNTControlBase from '../../util/TNTControlBase';

class NotificationManagementController extends TNTControlBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'notification_management'
    this.$state = $state

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_control_' + this.id]) {
      this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
    }
  }
}

export default NotificationManagementController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/notification_management.controller.js